import { Fragment, useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Dialog, Transition } from "@headlessui/react";
import CsvUploader from "../../components/modals/CsvUploader";
import { uploadStudentFile } from "../../actions/student.action";
import { Loading } from "../../utils/helpers/constants";
import RoundLoader from "../../components/loader/RoundLoader";
import toast from "react-hot-toast";

export default function FileUploadModal({ open, setOpen, cancelButtonRef }) {
  const dispatch = useDispatch();

  const [file, setFile] = useState("");
  const handleOnDrop = (event) => {
    if (event.target.files && event.target.files[0]) {
      const file = event.target.files[0];
      setFile(file);
    }
  };

  const handleSubmit = () => {
    if (file !== "") {
      dispatch(uploadStudentFile(file));
    } else {
      toast.error("No file has been selected!");
    }
  };

  const {
    student: { fileUploadLoading },
  } = useSelector(({ studentReducer }) => ({
    student: studentReducer,
  }));

  const downloadTemplate = () => {
    console.log("downloadTemplate");
  };

  useEffect(() => {
    const successState = fileUploadLoading === Loading.SUCCESS;
    if (successState) {
      setOpen(false);
    }
  }, []);

  const loadState = fileUploadLoading === Loading.FETCHING;

  return (
    <div>
      {loadState ? (
        <RoundLoader />
      ) : (
        <Transition.Root show={open} as={Fragment}>
          <Dialog
            as="div"
            className="relative z-10"
            initialFocus={cancelButtonRef}
            onClose={setOpen}
          >
            <Transition.Child
              as={Fragment}
              enter="ease-out duration-300"
              enterFrom="opacity-0"
              enterTo="opacity-100"
              leave="ease-in duration-200"
              leaveFrom="opacity-100"
              leaveTo="opacity-0"
            >
              <div className="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" />
            </Transition.Child>

            <div className="fixed z-10 inset-0 overflow-y-auto">
              <div className="flex items-end sm:items-center justify-center min-h-full p-4 text-center sm:p-0">
                <Transition.Child
                  as={Fragment}
                  enter="ease-out duration-300"
                  enterFrom="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
                  enterTo="opacity-100 translate-y-0 sm:scale-100"
                  leave="ease-in duration-200"
                  leaveFrom="opacity-100 translate-y-0 sm:scale-100"
                  leaveTo="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
                >
                  <Dialog.Panel className="relative bg-white rounded-lg text-center overflow-hidden shadow-xl transform transition-all sm:my-8 sm:max-w-lg sm:w-full">
                    <div className="bg-white px-4 pt-5 pb-4 sm:p-6 sm:pb-4">
                      <div className="sm:fle sm:items-star">
                        <div className="mt-3 text-center sm:mt-0 sm:ml-4 sm:text-center">
                          <Dialog.Title
                            as="h3"
                            className="text-lg leading-6 font-medium text-gray-900"
                          >
                            Upload CSV File
                          </Dialog.Title>
                          <div className="mt-2">
                            <p className="text-sm text-gray-500">
                              Click on the template button to download the
                              latest excel sheet template to upload pathfinder
                              details. Drag and drop your csv file or select
                              file from your folder.
                            </p>
                          </div>

                          <div className="cursor-pointer flex justify-center align-center mt-2 border-dashed border-2 border-green-800 rounded-md">
                            <p className="text-sm text-gray-500">{file.name}</p>
                          </div>
                          <CsvUploader
                            handleOnDrop={(e) => handleOnDrop(e)}
                            handleRemove={() => setFile("")}
                            downloadTemplate={() => downloadTemplate()}
                          />
                        </div>
                      </div>
                    </div>
                    <div className="bg-gray-50 px-4 py-3 sm:px-6 sm:flex sm:flex-row-reverse">
                      <button
                        type="button"
                        className="w-full inline-flex justify-center rounded-md border border-transparent shadow-sm px-4 py-2 bg-green-600 text-base font-medium text-white hover:bg-green-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-green-500 sm:ml-3 sm:w-auto sm:text-sm"
                        onClick={() => handleSubmit()}
                      >
                        Submit
                      </button>
                      <button
                        type="button"
                        className="mt-3 w-full inline-flex justify-center rounded-md border border-gray-300 shadow-sm px-4 py-2 bg-white text-base font-medium text-gray-700 hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500 sm:mt-0 sm:ml-3 sm:w-auto sm:text-sm"
                        onClick={() => setOpen(false)}
                        ref={cancelButtonRef}
                      >
                        Cancel
                      </button>
                    </div>
                  </Dialog.Panel>
                </Transition.Child>
              </div>
            </div>
          </Dialog>
        </Transition.Root>
      )}
    </div>
  );
}
